import React, { useEffect, useState } from 'react'
import { parseDateFormat } from 'src/helper/parseDateFormat';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { userServices } from 'src/services/reservation/user/user.service';
import { accountStateServices } from 'src/services/reservation/accout-state/AccountState.service';
import { Skeleton } from '@mui/material';
import { useTranslate } from 'react-admin';

export const HeaderInfo = () => {
    const translate = useTranslate()
    const [lastUpdateDate, setLastUpdateDate] = useState('')
    const [lastUpdateLoading, setLastUpdateLoading] = useState(false)
    const [exchangeAmount, setExchangeAmount] = useState([])
    const [currencyLoading, setCurrencyLoading] = useState(false)

    const getLastUpdateInfo = async () =>{
    setLastUpdateLoading(true)
    await accountStateServices.getLastUpdateInfo().then(res=>{
        setLastUpdateDate(res.updated_at)
        })
        .finally(()=>{
          setLastUpdateLoading(false)
        })
    }

    const getCurrencyExchange = async () =>{
    setCurrencyLoading(true)
    await userServices.getCurrencyByUser().then(res=>{
        setExchangeAmount(res.filter((currency) => !currency.is_reverse).map(amount=>{return {
        cur_symbol:amount?.currency_relation?.symbol, 
        cur_short_name:amount?.currency_relation?.short_name,
        to_symbol:amount?.currency_to_relation?.symbol, 
        to_short_name:amount?.currency_to_relation?.short_name,
        value:amount?.value
        }}))
    })
    .finally(()=>{
      setCurrencyLoading(false)
    })
    }

    useEffect(()=>{
        getLastUpdateInfo()
        getCurrencyExchange()
    },[])
  return (
    <div style={{margin:'10px', display:'flex', flexDirection:'row'}}>
            <div style={{ display:'flex', flexDirection:'row', marginRight:'10px', fontSize:'13px', alignItems:'center'}}>
              <AccessTimeIcon/>
              {`${translate('ra.field.update_at')}:`}
              <p style={{color:'#6f7ce0', width:'80%'}}>
                {lastUpdateLoading ?
                  <Skeleton width={'30%'}/>:
                  parseDateFormat(lastUpdateDate)
                }
              </p>
            </div>
            <div style={{ display:'flex', flexDirection:'row', marginRight:'10px', fontSize:'13px', alignItems:'center'}}>
              <AttachMoneyIcon/>
              {
                currencyLoading ?
                <Skeleton width={'30%'}/>
                :
                exchangeAmount?.map(exchange=>(
                  <p style={{display:'flex', flexDirection:'row', marginRight:'10px'}}>
                    {`${exchange.cur_symbol} ${exchange.cur_short_name} - ${exchange.to_symbol} ${exchange.to_short_name}: `}
                    <div style={{color:'#6f7ce0'}}>
                      {exchange.value}
                    </div>
                  </p>
                ))
              }
            </div>
          </div>
  )
}
